import { Country } from '@/constructs/Country';
import { Brand } from '@/constructs/Brand';
import Currency from '@/constructs/Currency';
import type { DTO } from '@/type-utils';
import type IShippingMethod from '../IShippingMethod';

const MOCK_SHIPPING_METHODS: Array<DTO<IShippingMethod>> = [
  {
    id: 'ST2',
    uid: 'a12zqsvev8iycpljra8umfkf',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Expedited Shipping',
    description: 'Standard 2 Day',
    shippingCost: { amount: '17', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: 2,
    latestDeliveryDays: 3,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: 'Arrives in 2-3 business days',
    deliveryMessageHTML: '<strong>Fast!</strong>',
    additionalMessage: 'Arrives in 2-3 business days',
    cutoffTime: '20:00:00',
    cutoffDisplay: 0
  },
  {
    id: 'SFS',
    uid: 'dfwtr9mv8odhdv55b1g4rzfq',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'SFS',
    description: 'SFS',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'Ontrac2Day',
    uid: 'ffnzxcl4t42nvkiw7vfoas42',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Ontrac2Day',
    description: 'Ontrac2Day',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'Same Day Ship Methods (SDD)',
    uid: 'g338ghat15wpqweta2omq53r',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Same Day Ship Methods (SDD)',
    description: 'Same Day Ship Methods (SDD)',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'USPS Express',
    uid: 'h13zkbhec0yi20h11efcrauy',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'USPS Express',
    description: 'USPS Express',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'OntracSunrise',
    uid: 'i13n7lrkf0uai46j179jja46',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'OntracSunrise',
    description: 'OntracSunrise',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'U43',
    uid: 'loxa3jpaktgig6arqpx7qksg',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'U43',
    description: 'U43',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'UPSGround',
    uid: 'm11bs4bp8ye3gl4s7d3w8owx',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'UPS Ground',
    description: 'UPSGround',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'S2S',
    uid: 'nj98m2plpzd101acmftr3ga5',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Ship to Store',
    description: 'S2S',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: 'Ready for pickup in 3-5 days',
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'USPS Ground',
    uid: 'ofewdejr4tt7q0zosp81iz5c',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'USPS Ground',
    description: 'USPS Ground',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'USPS Parcel Select',
    uid: 'p5s837kb1ndfvwpu074ac0x1',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'USPS Parcel Select',
    description: 'USPS Parcel Select',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'STG2',
    uid: 'q67jp4s33gn60oglnsuczgsh',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Standard Shipping',
    description: 'Standard Ground',
    shippingCost: { amount: '10', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: '2025-10-15',
    latestDeliveryDateOverride: '2025-10-20',
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: 'Includes tracking and insurance',
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'STO',
    uid: 'r14c7nztzmusds06lagst6j4',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Fastest Shipping',
    description: 'Standard Overnight',
    shippingCost: { amount: '28', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: 1,
    latestDeliveryDays: 2,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: 'Arrives tomorrow',
    deliveryMessageHTML: '<strong>Fast!</strong>',
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 24
  },
  {
    id: 'USPS Priority',
    uid: 's44mtsjtnyjgcwlnx6xcgktg',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'USPS Priority',
    description: 'USPS Priority',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'STG',
    uid: 't9ahyc85zyxa2vxixvzc9aug',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Standard Ground',
    description: 'Standard Ground Shipping',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: 3,
    latestDeliveryDays: 6,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'SPU',
    uid: 'u13bh7cxacxn3xkz1o7r6aw1',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'SPU',
    description: 'SPU',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'UPS2Day',
    uid: 'ur7u7rlkso2qb63fka2fndof',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'UPS2Day',
    description: 'UPS2Day',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'OntracGold',
    uid: 'vlfgq2xqfydh4quwzsc5msop',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'OntracGold',
    description: 'OntracGold',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'UPS3DaySelect',
    uid: 'x37c8npfqo7nwv4i2ixxltn3',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'UPS3DaySelect',
    description: 'UPS3DaySelect',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'SFS Standard International delivery',
    uid: 'z3rzyggduxgse14lgqqqjyyl',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'SFS Standard International delivery',
    description: 'SFS Standard International delivery',
    shippingCost: { amount: '75', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'Ontrac1Day',
    uid: 'zamzzb0oqdk4jb9iwgn0qrm8',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'Ontrac1Day',
    description: 'Ontrac1Day',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  },
  {
    id: 'UPR',
    uid: 'zzuuyevzl514m016oznbef0o',
    country: Country.US,
    brand: Brand.Ahnu,
    name: 'UPR',
    description: 'UPR',
    shippingCost: { amount: '0', currency: Currency.USD },
    tax: { amount: '0', currency: Currency.USD },
    taxRate: 0,
    earliestDeliveryDays: null,
    latestDeliveryDays: null,
    earliestDeliveryDateOverride: null,
    latestDeliveryDateOverride: null,
    formattedDeliveryEstimate: null,
    deliveryMessageHTML: null,
    additionalMessage: null,
    cutoffTime: '20:00:00',
    cutoffDisplay: 4
  }
];

export default MOCK_SHIPPING_METHODS;
